import FeaturesModel from "../../rest/user/model/FeaturesModel";

const isOrgDevFeatureEnabled = (features: FeaturesModel[]) => {
  const enabled = features.find((feature) => feature.name === "developer") !== undefined;
  return enabled;
};

export default isOrgDevFeatureEnabled;
